import React from 'react'
import { About } from '../../component/about/About'

export default function AboutPage() {
  return (
    <>
      <About />
    </>
  )
}
